import script from "./CardArrow.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardArrow.vue?vue&type=script&lang=ts&setup=true"

import "./CardArrow.vue?vue&type=style&index=0&id=faeaa836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faeaa836"]])

export default __exports__